import { Infer, string, type } from "superstruct";
import { getFirebaseFunctionDefinition } from "../../utils/getFirebaseFunctionDefinition";

const ExportCallsRequestStruct = type({
  projectId: string(),
  startDate: string(),
  endDate: string(),
});

const ExportCallsResponseStruct = type({
  csvContent: string(),
  filename: string(),
});

export type ExportCallsRequest = Infer<typeof ExportCallsRequestStruct>;
export type ExportCallsResponse = Infer<typeof ExportCallsResponseStruct>;

export const exportCallsDefinition = getFirebaseFunctionDefinition({
  path: "/calls/export",
  reqType: ExportCallsRequestStruct,
  resType: ExportCallsResponseStruct,
});
